import request from 'components/Utils/Request';
const { REACT_APP_API_URL } = process.env;
export const GET_SUBSCRIPTION_LIST_LIST_REQUEST = 'GET_SUBSCRIPTION_LIST_LIST_REQUEST';
export const GET_SUBSCRIPTION_LIST_LIST_SUCCESS = 'GET_SUBSCRIPTION_LIST_LIST_SUCCESS';
export const GET_SUBSCRIPTION_LIST_LIST_FAILURE = 'GET_SUBSCRIPTION_LIST_LIST_FAILURE';
export const SEND_RENEW_SUBSCRIPTION_MAIL_REQUEST = "SEND_INVOICE_MAIL_REQUEST";
export const SEND_RENEW_SUBSCRIPTION_MAIL_SUCCESS = "SEND_INVOICE_MAIL_SUCCESS";
export const SEND_RENEW_SUBSCRIPTION_MAIL_FAILURE = "SEND_INVOICE_MAIL_FAILURE";

  export const getClientSubscriptionListRequest = () => ({
    type: GET_SUBSCRIPTION_LIST_LIST_REQUEST
  });
  export const getClientSubscriptionListSuccess = payload => ({
    type: GET_SUBSCRIPTION_LIST_LIST_SUCCESS,
    payload
  });
  export const getClientSubscriptionListFailure = payload => ({
    type: GET_SUBSCRIPTION_LIST_LIST_FAILURE,
    payload
  });

  export const  sendRenewSubscriptionMailRequest = () => ({
    type: SEND_RENEW_SUBSCRIPTION_MAIL_REQUEST
  });
  export const  sendRenewSubscriptionMailSuccess = (payload) => ({
    type: SEND_RENEW_SUBSCRIPTION_MAIL_SUCCESS,
    payload
  });
  export const  sendRenewSubscriptionMailFailure = (payload) => ({
    type: SEND_RENEW_SUBSCRIPTION_MAIL_FAILURE,
    payload
  })

  export const SubscriptionDetailAction = payload => {
    return {
      type: 'SUBSCRIPTIONDETAIL',
      payload
    };
  };
  export const getClientSubscriptionListAPI = (payload, successData, errorMSg, headers = {}) => {
    return dispatch => {
      dispatch(getClientSubscriptionListRequest());
      return request(
        'POST',
        `${REACT_APP_API_URL + '/client-subscription-list'}`,
        payload,
        "",
        headers
      )
        .then(res => {
          if (res?.data.status === 200) {
            successData(res);
            dispatch(getClientSubscriptionListSuccess(res.data.data.clientSubcription));
          } else {
            errorMSg(res);
          }
        })
        .catch(err => {
          errorMSg(err?.res);
          dispatch(getClientSubscriptionListFailure('Something went wrong'));
          throw err;
        });
    };
  };

  export const  sendRenewSubscriptionMailAPI = (payload, successData, errorMsg,headers = {}) => {
    return dispatch => {
      dispatch( sendRenewSubscriptionMailRequest());
      const url = `${REACT_APP_API_URL}/send-subscription-renew-mail/${payload}`;
      return request('GET', url, "", "", headers)  
      .then(response => {
        if (response?.data?.status === 200) {
        successData(response);
        dispatch( sendRenewSubscriptionMailSuccess(response));
        } else {
        errorMsg(response);
        }
      })
      .catch(error => {
        errorMsg(error?.response);
        dispatch( sendRenewSubscriptionMailFailure('Something went wrong'));
        throw error;
      });
    };
    };